/* eslint-disable no-console */
import { chain, get, has, isEmpty } from 'lodash';

const preprocessBase64 = (c: string): string => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`;

const decodeBase64 = (base64: string): string =>
  decodeURIComponent(atob(base64).split('').map(preprocessBase64).join(''));

const parseJsonSafe = (data = ''): unknown[] | null => {
  try {
    return JSON.parse(data) as [];
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const parseJwtToken = (token: string): Record<string, unknown> | null => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeBase64(base64);
    return JSON.parse(jsonPayload);
  } catch (e) {
    console.error(e as Error);
    return null;
  }
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const getUserData = (tokenData: Record<string, unknown> | null) => {
  if (!tokenData || isEmpty(tokenData) || !has(tokenData, 'user_id')) {
    return undefined;
  }
  const { name = '', user_id: userId = '' } = { ...tokenData };
  const permissions = chain(parseJsonSafe(get(tokenData, 'user_permissions') as string))
    .map((p) => ({ ...(p as object), permission: get(p, 'Permission.0') }))
    .keyBy('permission')
    .value();

  return {
    userId: String(userId),
    name: String(name),
    permissions,
    externalRights: parseJsonSafe(get(tokenData, 'external_rights') as string),
  };
};

export type UserInfo = ReturnType<typeof getUserData>;
